import React from 'react';
import Textarea from '../shared/Textarea';
import Button from '../shared/Button';
import { extractTextFromPDF } from '../../utils/pdfExtractor';
import './StageOne.css';

const StageOne = ({ formData, setFormData, onNext }) => {
  const [error, setError] = React.useState(null);
  const [uploadStatus, setUploadStatus] = React.useState(null);
  const [isProcessing, setIsProcessing] = React.useState(false);
  const fileInputRef = React.useRef(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      kernel_text: e.target.value
    });
    setError(null);
  };

  const handleFileSelect = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validate file type
    if (file.type !== 'application/pdf') {
      setError('Only PDF files are allowed');
      return;
    }

    // Validate file size (10MB limit)
    if (file.size > 10 * 1024 * 1024) {
      setError('File too large. Maximum size is 10MB.');
      return;
    }

    setIsProcessing(true);
    setUploadStatus('Processing...');
    setError(null);

    try {
      // Extract text from PDF on the client side
      const result = await extractTextFromPDF(file);

      setFormData({
        ...formData,
        attachment_text: result.text
      });

      setUploadStatus('✓ File processed successfully');
    } catch (err) {
      setError(err.message);
      setUploadStatus(null);
    } finally {
      setIsProcessing(false);
    }
  };

  const handleRemoveAttachment = () => {
    setFormData({
      ...formData,
      attachment_text: null
    });
    setUploadStatus(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const handleContinue = () => {
    const text = formData.kernel_text.trim();

    if (text.length < 10) {
      setError('Belief must be at least 10 characters');
      return;
    }

    if (text.length > 2000) {
      setError('Belief must be less than 2000 characters');
      return;
    }

    onNext();
  };

  return (
    <div className="stage-one">
      <Textarea
        label="Your Belief"
        value={formData.kernel_text}
        onChange={handleChange}
        placeholder="I believe that..."
        required
        maxLength={1000}
        showCounter
        error={error}
        rows={6}
      />

      <div className="stage-one__upload">
        <label className="stage-one__upload-label">Supporting Document (Optional)</label>
        <input
          ref={fileInputRef}
          type="file"
          accept=".pdf"
          onChange={handleFileSelect}
          disabled={isProcessing}
          className="stage-one__file-input"
          id="pdf-upload"
        />
        <label htmlFor="pdf-upload" className="stage-one__upload-button">
          {isProcessing ? 'Processing...' : 'Upload PDF'}
        </label>

        {uploadStatus && (
          <div className="stage-one__upload-status">
            <span className="stage-one__upload-status-text">{uploadStatus}</span>
            <button
              type="button"
              onClick={handleRemoveAttachment}
              className="stage-one__upload-remove"
            >
              Remove
            </button>
          </div>
        )}
      </div>

      <div className="stage-one__actions">
        <Button
          onClick={handleContinue}
          variant="primary"
          fullWidth
        >
          Continue →
        </Button>
      </div>
    </div>
  );
};

export default StageOne;
